module.exports = __webpack_public_path__ + "img/point.9fbb805c.svg";